export default "__VITE_ASSET__9fe9a85c__"